<template lang="pug">
    v-card.SingleOptionQuestion.px-sm-5(v-if="currentStep.question" justify-center flat)
      v-card-text.titleS
        | {{currentStep.question.title}}
        ul.lista(v-if="currentStep.question.list")
          li(v-for="l in currentStep.question.list") {{l}}
      v-layout(row, justify-center)
        v-flex.md10()
          v-radio-group.justify-center.radioS(v-model="currentStep.question.answer" @change="changeValue" row )              
              div(v-for="option in currentStep.question.options")                
                v-radio.radius(:readonly="currentStep.question.answer && currentStep.check"
                  color="primary" :label="option.label" :value="option")
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'SingleOptionQuestion',
  computed: {
    ...mapGetters(['currentStep'])
  },
  data() {
      return {
          answer: null
      }
  },
  methods: {
      changeValue(value) {   
        this.currentStep.answered = true;        
      }
  }
}
</script>

<style scoped>
@import 'single-option-question.scss';
</style>
